import React from 'react';

import ParagraphCTA from './Default';
import ParagraphCTAGetStarted from './GetStarted';

const Video = (props) => {
  const { viewMode } = props;

  if (viewMode === 'getStarted') {
    return <ParagraphCTAGetStarted {...props} />;
  }

  return <ParagraphCTA {...props} />;
};

export default Video;
